import React, { useState, useEffect, useRef } from 'react';
import api from '../api';

// Search box for a city / state / region inside the site's country.
// onSelect({code, name}) on a pick; onClear() for "back to the default".
export function locationLabel(name) {
  // "Rockville,Maryland,United States" -> "Rockville, Maryland"
  if (!name) return '';
  var parts = name.split(',');
  if (parts.length > 1) parts = parts.slice(0, -1);
  return parts.join(', ');
}

export default function LocationPicker({ siteId, value, onSelect, onClear, clearLabel, placeholder, style }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const timer = useRef(null);
  const seq = useRef(0);

  useEffect(() => {
    clearTimeout(timer.current);
    if (q.trim().length < 2) { setResults([]); setLoading(false); return; }
    setLoading(true);
    timer.current = setTimeout(async () => {
      const mine = ++seq.current;
      try {
        const data = await api.searchLocations(siteId, q.trim());
        if (mine === seq.current) { setResults(data.locations || []); setError(''); }
      } catch (err) {
        if (mine === seq.current) setError(err.message);
      }
      if (mine === seq.current) setLoading(false);
    }, 300);
    return () => clearTimeout(timer.current);
  }, [q, siteId]);

  function pick(loc) {
    onSelect({ code: loc.code, name: loc.name });
    setQ(''); setResults([]); setOpen(false);
  }

  const box = { padding: '6px 8px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--bg)',
                color: 'var(--text)', fontSize: '12px', fontFamily: 'inherit', direction: 'ltr', width: '100%' };

  return (
    <div style={{ position: 'relative', minWidth: '220px', ...style }}>
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        <input value={q} onChange={e => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
               onBlur={() => setTimeout(() => setOpen(false), 150)}
               placeholder={value ? locationLabel(value) : (placeholder || 'Search city / state...')} style={box} />
        {value && onClear && (
          <button type="button" className="btn-sm" onClick={onClear} style={{ fontSize: '11px', padding: '3px 8px', whiteSpace: 'nowrap' }}>
            {clearLabel || 'ניקוי'}
          </button>
        )}
      </div>
      {open && (q.trim().length >= 2) && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 20, marginTop: '2px', maxHeight: '260px', overflowY: 'auto',
                      background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '6px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
          {loading && <div style={{ padding: '8px 10px', fontSize: '12px', color: 'var(--text-muted)' }}>מחפש...</div>}
          {!loading && error && <div style={{ padding: '8px 10px', fontSize: '12px', color: 'var(--red)' }}>{error}</div>}
          {!loading && !error && results.length === 0 && <div style={{ padding: '8px 10px', fontSize: '12px', color: 'var(--text-muted)' }}>לא נמצאו מיקומים</div>}
          {!loading && results.map(loc => (
            <div key={loc.code} onMouseDown={e => { e.preventDefault(); pick(loc); }}
                 style={{ padding: '7px 10px', cursor: 'pointer', fontSize: '12px', direction: 'ltr', textAlign: 'left',
                          display: 'flex', justifyContent: 'space-between', gap: '8px', borderBottom: '1px solid var(--border)' }}>
              <span style={{ color: 'var(--text)' }}>{locationLabel(loc.name)}</span>
              <span style={{ color: 'var(--text-muted)', fontSize: '11px' }}>{loc.type}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
